"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backdrop = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const overlay_styles_1 = require("@/components/overlay/overlay.styles");
/**
 * modal 표면 뒤를 덮는 dim·blur 레이어.
 * 콘텐츠 없이 재질만 책임지며, 열림/닫힘은 자신을 품은 레이어가 소유한다.
 */
let Backdrop = class Backdrop extends lit_1.LitElement {
};
Backdrop.styles = overlay_styles_1.backdropStyles;
Backdrop = __decorate([
    (0, decorators_js_1.customElement)('mm-backdrop')
], Backdrop);
exports.Backdrop = Backdrop;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFja2Ryb3AuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJiYWNrZHJvcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBZ0M7QUFDaEMscURBQWlEO0FBRWpELHdFQUFvRTtBQUVwRTs7O0dBR0c7QUFFSSxJQUFNLFFBQVEsR0FBZCxNQUFNLFFBQVMsU0FBUSxnQkFBVTs7QUFDL0IsZUFBTSxHQUFHLCtCQUFjLENBQUE7QUFEbkIsUUFBUTtJQURwQixJQUFBLDZCQUFhLEVBQUMsYUFBYSxDQUFDO0dBQ2hCLFFBQVEsQ0FFcEI7QUFGWSw0QkFBUSJ9